import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Observable } from 'rxjs';
import { CloudApiService } from '../../../services/cloud-api.service';
import { BranchDto } from '../../../services/dtos/branch.dto';
import { SearchDto } from '../../../services/dtos/search.dto';
import { ReportConfig } from '../../../reports/dtos/interfaces/report-config';
import { ReportDescriptor } from '../../../reports/dtos/interfaces/report-descriptor';
import { ReportState } from '../../../reports/dtos/enums/report-state';

@Component({
    selector: 'app-report-body',
    template: require('./report-body.component.html'),
})
export class ReportBodyComponent implements OnChanges {
    @Input() config: ReportConfig | null = null;
    @Input() branch: BranchDto | null = null;
    @Input() searchQuery: SearchDto | null = null;
    @Output() descriptor = new EventEmitter<ReportDescriptor>();
    @Output() failed = new EventEmitter<string>();

    states = ReportState;
    state = ReportState.None;
    rows: any[] = [];
    totalRows: number;

    constructor(private api: CloudApiService) {}

    ngOnChanges(): void {
        // branch starts as an empty BranchDto (id undefined) until loadBranches resolves - guard on id
        if (!this.config || !this.branch || this.branch.id == null || !this.searchQuery) return;
        this.run(this.config, this.branch, this.searchQuery);
    }

    private run(config: ReportConfig, branch: BranchDto, search: SearchDto): void {
        this.state = ReportState.Loading;
        this.api.getReport<any>(config.endpoint, branch.id, search)
            .map(data => {
                if (data.error) throw data.error;
                this.totalRows = data.totalRows;
                return config.mapRows(data.rows, search);
            })
            .catch(err => {
                this.state = ReportState.Error;
                this.failed.emit(typeof err === 'string' ? err : 'Failed to load report.');
                return Observable.of([] as any[]);
            })
            .subscribe(rows => {
                this.rows = rows;
                if (this.state !== ReportState.Error) this.state = ReportState.Ready;
                this.descriptor.emit({ title: config.label, columns: config.columns, rows, totalRows: this.totalRows });
            });
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/components/reports/report-body/report-body.component.ts